import { Link } from "react-router-dom";
import { Home, ShieldOff } from "lucide-react";
import { Button } from "antd";

const Forbidden = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-8">
        <div className="flex justify-center">
          <ShieldOff className="h-16 w-16 text-destructive opacity-80" />
        </div>
        <div className="space-y-2">
          <p className="text-8xl font-extrabold">403</p>
          <h1 className="text-2xl font-bold tracking-tight">Access Denied</h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            You don&apos;t have permission to view this page. This area is
            restricted to authorised users only.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button icon={<Home className="h-4 w-4" />}>
            <Link to="/shoup-community/dashboard">Go to Dashboard</Link>
          </Button>
          <Button
            type="default"
            onClick={() => window.history.back()}
          >
            Go Back
          </Button>
        </div>

        <div className="pt-4 border-t border-border/50">
          <p className="text-xs text-muted-foreground">
            If you believe this is a mistake, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
